$(document).ready(function(){
  $('#Banner-template--15385296535724__16460695145db4b08f').click(function() {
   window.location = "https://www.dustandbeau.shop";
	});
});


$(document).ready(function(){
  $('#Banner-template--15660564676780__16460695145db4b08f').click(function() {
   window.location = "/collections/jackets-hoods";
	});
});






$(document).ready(function(){
var countDownDate = new Date("June 5, 2022 15:37:25").getTime();
var x = setInterval(function() {
  var now = new Date().getTime();
  var distance = countDownDate - now;
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  document.getElementById("sale-countdown").innerHTML = days + "d " + hours + "h "
  + minutes + "m " + seconds + "s ";
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("sale-countdown").innerHTML = "SALE ENDED";
  }
}, 1000);

});